var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcJs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#FFCA28",
    fillOpacity: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 12,
    fill: "url(#paint0_linear)",
    fillOpacity: 0.16
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2056 20.1738H23.7209V28.9332C23.7209 30.1613 23.3844 31.1462 22.7114 31.8877C22.0383 32.6292 21.1714 33 20.1105 33C18.9697 33 18.0828 32.6553 17.4497 31.9659C16.8166 31.2765 16.5 30.3177 16.5 29.0896H19.0239C19.0239 30.283 19.3861 30.8797 20.1105 30.8797C20.8405 30.8797 21.2056 30.1903 21.2056 28.8115V20.1738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.959 29.5067C30.959 28.9911 30.8278 28.6029 30.5654 28.3422C30.3088 28.0758 29.8382 27.8006 29.1537 27.5167C27.9046 27.0359 27.0063 26.4739 26.4587 25.8309C25.9112 25.182 25.6374 24.4173 25.6374 23.5368C25.6374 22.4708 26.0081 21.6163 26.7496 20.9733C27.4968 20.3244 28.4436 20 29.5901 20C30.3544 20 31.036 20.1651 31.6349 20.4953C32.2338 20.8197 32.6929 21.2803 33.0123 21.877C33.3374 22.4737 33.5 23.1515 33.5 23.9104H30.9932C30.9932 23.3195 30.8677 22.8705 30.6168 22.5635C30.3715 22.2507 30.015 22.0943 29.5473 22.0943C29.1081 22.0943 28.7659 22.2275 28.5206 22.494C28.2754 22.7547 28.1527 23.1081 28.1527 23.5541C28.1527 23.9017 28.2896 24.2175 28.5634 24.5013C28.8372 24.7794 29.322 25.0691 30.0179 25.3703C31.2328 25.8164 32.114 26.3639 32.6615 27.0127C33.2148 27.6615 33.4914 28.4871 33.4914 29.4893C33.4914 30.59 33.1464 31.4503 32.4562 32.0702C31.7661 32.6901 30.8278 33 29.6414 33C28.8372 33 28.1043 32.832 27.4426 32.496C26.781 32.16 26.262 31.6791 25.8855 31.0535C25.5148 30.4278 25.3294 29.6892 25.3294 28.8376H27.8533C27.8533 29.5675 27.993 30.0976 28.2725 30.4278C28.552 30.758 29.0083 30.9231 29.6414 30.9231C30.5198 30.9231 30.959 30.451 30.959 29.5067Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b",
    x: -9.5,
    y: -10,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 12.5,
    y: 18,
    width: 25,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcJs);
export default __webpack_public_path__ + "static/media/ic_js.0a88344cca1fc6b9f428c6f5e95fbf00.svg";
export { ForwardRef as ReactComponent };